import React__default from 'react';
import { SvgImg } from '../../../components/svgImg/svgImg.js';

const FlagFR = ({ width = '24', height = '24' }) => (React__default.createElement(SvgImg, { viewbox: "0 0 24 24", title: "merchant-center / flags / flagFR", width: width, height: height },
    React__default.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#F0F0F0" }),
    React__default.createElement("path", { d: "M23.9999 11.9999C23.9999 6.84037 20.7434 2.44185 16.1738 0.746338V23.2536C20.7434 21.558 23.9999 17.1595 23.9999 11.9999Z", fill: "#D80027" }),
    React__default.createElement("path", { d: "M0 11.9999C0 17.1595 3.25655 21.558 7.82611 23.2536V0.746338C3.25655 2.44185 0 6.84037 0 11.9999Z", fill: "#0052B4" })));

export { FlagFR };
